import * as React from 'react';
import { ArticleParagraph1, ILabelProps, Label } from '@cian/ui-kit';

import * as styles from './styles.css';
import { IInformerBanner } from '../../../types/informerBanner';

export const MobileBannerLayout: React.FC<IInformerBanner['bannerData']> = ({ description, mobileData }) => {
  return (
    <div className={styles['banner']} style={{ background: mobileData.backgroundGradient }}>
      <div className={styles['title']}>
        {mobileData?.labelData && (
          <Label
            background={mobileData.labelData.labelBackground as ILabelProps['background']}
            color={mobileData.labelData.labelColor as ILabelProps['color']}
          >
            {mobileData.labelData.labelText}
          </Label>
        )}

        <ArticleParagraph1>{description}</ArticleParagraph1>
      </div>

      <div className={styles['icon']}>
        <img src={mobileData.iconUrl} />
      </div>
    </div>
  );
};
